import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { FormContextProvider, DisplaySpinnerContext } from "../../../context/ContextIndex";
import { AppForm, DynamicFormContainer, notifyToast, ToastType, TabPanel } from "../../../components";
import { getItineraryTimesDefaultValue, getItineraryTimesSchema } from "./Schema";
import { selectSessionConfig } from "../../../store/store-selector";
import { useFetchListData } from "../../../hooks/useFetchListData";
import { saveItineraryTimes } from "../api-handler/api-handler";
import AppFormRootContainer from "../../../components/app-components/app-form-root-container/AppFormRootContainer";

const CreateItineraryTimesForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const EditItineraryTimesId = searchParams.get("itineraryTimesId");
  const spinnerCtx = useContext(DisplaySpinnerContext);
  const settingsConfig = useSelector(selectSessionConfig);
  const navigationData = location.state;
  const DeviceTypeList = useFetchListData(settingsConfig.businessCode, settingsConfig.countryCode, "getDeviceType", "devicetype");

  const [formdata, setFormdata] = useState({
    schema: getItineraryTimesSchema([{ id: null, label: null }], EditItineraryTimesId),
    appformdata: null,
  });

  const defaultValue = getItineraryTimesDefaultValue();

  const handleCancel = () => {
    try {
      navigate("/itineraryTimeslist");
    } catch (err) {
      alert(err);
    }
  };

  const onItineraryTimesSubmit = async (data, formhandler) => {
    console.log("onItineraryTimesSubmit");
    const { reset, clearErrors } = formhandler;
    try {
      clearErrors();
      spinnerCtx.setLoadingIndicator(true);
      const status = await saveItineraryTimes(data, {
        EditItineraryTimesId,
        settingsConfig,
        formdata: formdata.appformdata,
      });

      if (status?.responseStatus === 200) {
        notifyToast("Sent for Approval", ToastType.SUCCESS);
        handleCancel();
      } else {
        notifyToast(status.errorMessage ? status.errorMessage : "Itinerary times creation failed", ToastType.ERROR);
        spinnerCtx.setLoadingIndicator(false);
      }
      if (status?.error) {
        reset(
          { ...data },
          {
            keepValues: true,
            keepSubmitCount: false,
            keepDirty: true,
            keepTouched: true,
          }
        );
      }
    } catch (err) {
      reset(
        { ...data },
        {
          keepValues: true,
          keepSubmitCount: false,
          keepDirty: true,
          keepTouched: true,
        }
      );
      alert(err);
    }
  };

  useEffect(() => {
    const setFormSchema = (recordlist) => {
      try {
        let _deviceTypeList = [];
        if (recordlist.length) {
          let _formData = navigationData ? { ...navigationData } : null;

          _deviceTypeList = recordlist.map((item) => {
            if (_formData && item.DeviceTypeId === _formData.DeviceTypeId) {
              _formData.DeviceType = {
                id: item.DeviceTypeId,
                label: item.TypeName,
              };
            }
            return {
              id: item.DeviceTypeId,
              label: item.TypeName,
            };
          });

          if (_formData) {
            setFormdata((prevstate) => ({
              ...prevstate,
              schema: getItineraryTimesSchema(_deviceTypeList, EditItineraryTimesId),
              appformdata: getItineraryTimesDefaultValue(_formData),
            }));
          } else {
            setFormdata((prevstate) => ({
              ...prevstate,
              schema: getItineraryTimesSchema(_deviceTypeList),
            }));
          }
        }
      } catch (err) {
        alert(err);
      } finally {
        spinnerCtx.setLoadingIndicator(false);
      }
    };

    spinnerCtx.setLoadingIndicator(true);
    if (DeviceTypeList) {
      setFormSchema(DeviceTypeList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [DeviceTypeList]);

  return (
    <AppFormRootContainer>
      <TabPanel
        tabs={[
          {
            icon: "",
            label: t("navigationMenu.itineraryTimes"),
            children: (
              <FormContextProvider schema={formdata.schema} defaultValues={defaultValue} appformdata={formdata.appformdata}>
                <AppForm onSubmit={onItineraryTimesSubmit}>
                  <DynamicFormContainer
                    header={EditItineraryTimesId ? t("createItineraryTimes.editHeader") : t("createItineraryTimes.createHeader")}
                    onCancel={handleCancel}
                  />
                </AppForm>
              </FormContextProvider>
            ),
          },
        ]}
        selectedTab="0"
        onTabChange={() => { }}
      />
    </AppFormRootContainer>
  );
};

export default CreateItineraryTimesForm;
